import React, { Fragment, useEffect } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Checkbox,
} from "@material-ui/core/";

import withStyles from "@material-ui/core/styles/withStyles";


interface IProps {
  data: EnvTempSections;
  envStyles: EnvTempStyles;
  tabName: string;
}
const IconLeftAccordionSummary = withStyles({
  expandIcon: {
    transform: "rotate(180deg)",
    order: -1,
  },
})(AccordionSummary);
export const GenericGuideAccordion: React.FC<IProps> = (props: IProps) => {
  const styles = {
    summ_1st: {
      background: props.envStyles.themeBackground,
      // outline: "#c1d300 2px solid",
      color: props.envStyles.color,
      marginTop: "5px",
    },
    summ_2nd: {
      background: props.envStyles.themeItemBackground,
      color: props.envStyles.color,
      marginTop: "0px",
      borderRadius: "10px",
      //   width: "100%",
    },
    check_box: {
      color: props.envStyles.themeItemBackground,
      marginTop: "0px",
    },
    check_radio: {
      color: props.envStyles.color,
      marginTop: "15px",
    },
    button: {
      background: props.envStyles.themeItemBackground,
      color: props.envStyles.color,
      marginTop: "10px",
      width: "150px",
    },
    detail_1st: {
      padding: "10px 0px",
      // border: "black solid 2px",
    },
    accord_2nd: {
      boxShadow: "none",
      width: "100%",
    },
  };
  const [expanded, setExpanded] = React.useState<string | false>(false);

  // const perSection = 100 / Object.keys(props.data).length;
  return (
    <Fragment>
      {Object.keys(props.data.subThemes).map((section: string) => {
        return (
          <Fragment key={section}>
            <GenericAccordionSubTheme
              expanded={expanded}
              setExpanded={setExpanded}
              {...props}
              section={section}
              styles={styles}
            />
          </Fragment>
        );
      })}
    </Fragment>
  );
};

interface GenericAccordionDetailsProps {
  styles: {
    summ_1st: {
      background: string;
      color: string;
      marginTop: string;
    };
    summ_2nd: {
      background: string;
      color: string;
      marginTop: string;
    };
    check_box: {
      // background: string;
      color: string;
      marginTop: string;
    };
    check_radio: {
      // background: string;
      color: string;
      marginTop: string;
    };
    button: {
      background: string;
      color: string;
      marginTop: string;
      width: string;
    };
    detail_1st: {
      padding: string;
    };
    accord_2nd: {
      boxShadow: string;
    };
  };
  themeItem: ThemeItem;
  amount: number;
  tabName: string;
  setCompleted(themeItem: number, completed: boolean): void;
}
const GenericAccordionDetails: React.FC<GenericAccordionDetailsProps> = (
  props: GenericAccordionDetailsProps
) => {

 

  return (
    <AccordionDetails style={props.styles.detail_1st}>
      <Accordion style={props.styles.accord_2nd}>
        <IconLeftAccordionSummary
          style={props.styles.summ_2nd}
        >
          {/* <img src={susenergyimg} className="heading_img_2" /> */}

          <div style={{ textAlign: "center", width: "100%" }}>
            <div className="heading_2">
              <span className="heading_2_main">{props.themeItem.title}</span>
              <br />
            </div>
          </div>
        </IconLeftAccordionSummary>
        <AccordionDetails
          style={{
            borderStyle: "solid",
            borderColor: "lightGrey",
            borderWidth: 5,
            borderRadius: "15px",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <div dangerouslySetInnerHTML={{__html: props.themeItem.guide}}></div>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </AccordionDetails>
  );
};

interface SubThemeProps {
  section: string;
  styles: {
    summ_1st: {
      background: string;
      // outline: "#c1d300 2px solid",
      color: string;
      marginTop: string;
    };
    summ_2nd: {
      background: string;
      color: string;
      marginTop: string;
      borderRadius: string;
    };
    check_box: { color: string; marginTop: string };
    check_radio: { color: string; marginTop: string };
    button: {
      background: string;
      color: string;
      marginTop: string;
      width: string;
    };
    detail_1st: { padding: string };
    accord_2nd: { boxShadow: string; width: string };
  };
  data: EnvTempSections;
  envStyles: EnvTempStyles;
  tabName: string;
  expanded: string | false;
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>;
}
const GenericAccordionSubTheme: React.FC<SubThemeProps> = (
  props: SubThemeProps
) => {
  const [completedThemeItems, setCompletedThemeItems] = React.useState<
    number[]
  >([]);
  function setCompleted(themeItem: number, completed: boolean) {
    if (completed) {
      if (!completedThemeItems.includes(themeItem)) {
        completedThemeItems.push(themeItem);
      }
    } else {
      const newCompleted = completedThemeItems.filter(
        (includedThemeItem) => includedThemeItem !== themeItem
      );
      setCompletedThemeItems(newCompleted);
    }
  }
  useEffect(() => {
    const newCompleted: number[] = [];
    props.data.subThemes[props.section].themeItems.map(
      (themeItem: ThemeItem) => {
        if (themeItem.completed) {
          newCompleted.push(themeItem.id);
        }
      }
    );
    setCompletedThemeItems(newCompleted);
  }, []);
  return (
    <Accordion
      expanded={props.expanded === props.section}
      onChange={() => {
        if (props.expanded === props.section) {
          props.setExpanded(false);
        } else {
          props.setExpanded(props.section);
        }
      }}
      style={{ boxShadow: "none" }}
    >
      <AccordionSummary
        style={props.styles.summ_1st}
        expandIcon={<ExpandMoreIcon style={props.styles.check_radio} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <img
          src={props.data.subThemes[props.section].img}
          // style={{ width: "35px", height: "35px",  }}
          className="template_summ_2_image"
        />
        <p className="heading_1">{props.section}</p>
      </AccordionSummary>
      {props.data.subThemes[props.section].themeItems.map(
        (themeItem: ThemeItem) => {
          return (
            <Fragment key={themeItem.id}>
              <GenericAccordionDetails
                styles={props.styles}
                themeItem={themeItem}
                amount={1}
                tabName={props.tabName}
                setCompleted={setCompleted}
              />
            </Fragment>
          );
        }
      )}
    </Accordion>
  );
};